import { cr, URLS as URLS1, ck, interact } from "fire-wind-water";
import api from "./core/services/api";

const URLS = {};
const jsApiList = ["getCurExternalContact","openEnterpriseChat","openExistedChatWithMsg","shareAppMessage","onMenuShareAppMessage","onMenuShareWechat","onMenuShareTimeline"];
let SURL = {};

function setURL(s) {
  URLS.url = s;
}

function setUploadURL(s) {
  URLS.UploadUrl = s;
}

function setCacheUrl(s) {
  URLS.cacheUrl = s;
}

function setDomain(s) {
  URLS.domain = s;
}

export const rs = {};

function resetURL(sett) {
  SURL = cr.extend(true, {}, sett);
  setUploadURL(SURL.template.api.ungateway.contentUrl);
  setURL(SURL.template.api.gateway.general + "/");
  setCacheUrl(SURL.template.apiCacheUrl);
  setDomain(SURL.domain || SURL.template.cookie.domain || "smarket.net.cn");
}

//weWork方面判断是否微信公众号授权的逻辑
//1企微环境下不任何环境走授权，
//2微信环境下 微信环境下    url带 weworkAuth=1  且 cookie下有  programId&&programUserId_tenantId 不走微信前端授权
function isInWechatAuth(tenantId) {
  const ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/micromessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork'){//企微环境
    return false;
  }else if (ua.match(/micromessenger/i) == 'micromessenger' &&
    (URLS1.getURL('weworkAuth') || URLS1.getHash('weworkAuth')) &&
    ck.cookie('programId') &&
    ck.cookie('programUserId_' + tenantId)
  ){//微信环境
    return false;
  }
  if(window.parent != window){
    return false;
    //iframe 中不授权
  }
  return true;
}

//获取打开客户端类型 browser ：浏览器，weChat:微信，wxWork：企微 用于判断不同类型的授权
function agentType() {
  const ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/micromessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork') {//企微环境
    return 'wxWork';
  }else if (ua.match(/micromessenger/i) == 'micromessenger'){
    return 'weChat';
  }else {
    return 'browser';
  }
}

function getHashSearchParam() {
  const url = location.href;
  // 获取 hash 值，不包含 '#' 号
  const hash = url.substring(url.indexOf("#") + 1);
  // 查找 '?' 号所在的索引
  const searchIndex = hash.indexOf("?");
  // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
  const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : "";
  // 把搜索参数字符串提过URLSearchParams转成对象形式
  const usp = new URLSearchParams(search);
  let hashStr = usp.toString();
  // 通过URLSearchParams自带的get方法，查询键所对应的值
  return hashStr;
}

//获取地址栏的渠道追踪参数写入cookies
function saveChannelParams() {
  ck.json = true;
  const hashStr = getHashSearchParam();
  let searchStr = window.location.search.substr(1);
  if ( hashStr ) {
    searchStr = searchStr + "&" + hashStr;
  }
  var searchArr = searchStr.split("&");
  var paramsList = [
    "globalUserId",
    "weChatId",
    "tenantId",
    "instanceId",
    "moduleId",
    "configId",
    "randNum",
    "linkId",
    "return_url",
    "customFormId",
    "questionaryId",
    "pollId",
    "luckyDrawId",
    "articleId",
    "memberFormId",
    "folderId",
    "accKey", "articleCategoryId", "fileId","memberSchemaId","sourceKey","webinarId","backUrl","memberId"
  ];
  for (var i = 0; i < searchArr.length; i++) {
    var d = searchArr[i].split("=");
    if (paramsList.indexOf(d[0]) === -1 && d[1] !== "" && d[1] !== null && d[1] !== undefined) {
      let temp = decodeURIComponent(d[1].toString());
      if (temp.indexOf("#") !== -1) {
        temp = temp.substring(0, temp.indexOf("#"));
      }
      ck.cookie(`channel_${d[0]}`, temp, {
        expires: 1 / 12,
        domain: window.$sk.config.domain,
        path: "/"
      });
    }
  }
}
 function getChannelParams() {
  //增加来源渠道参数
  const channelList = ck.cookie();
  const browseChannel = interact.browseInfo;
  // 循环遍历对象的属性
  for (const val in channelList) {
    // eslint-disable-next-line no-prototype-builtins
    if (
        // eslint-disable-next-line no-prototype-builtins
        channelList.hasOwnProperty(val) &&
        val.indexOf("channel_") !== -1
    ) {
      const temp = val.replace("channel_", "");
      browseChannel[temp] = channelList[val];
    }
  }
  return browseChannel;
}

let initJsSdk = function (tenantId,callBack) {
  api.getJsSdk({
    tenantId: tenantId,
    url: window.location.href.split("#")[0],
    jsApiList: jsApiList,
    onDebug: 0,
    type: 2,
  }).subscribe(res => {
    window.wx.agentConfig({
      ...res.content.config,
      success(res) {
        res;
        if(callBack){
          callBack();
        }
      }
    })
  })
}

export { URLS };
export {
  URLS as URL,
  SURL,
  setURL,
  setUploadURL,
  resetURL,
  setDomain,
  setCacheUrl,
  isInWechatAuth,
  agentType,
  saveChannelParams,
  getChannelParams,
  initJsSdk,
};
